<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="position-relative" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-4">
            <label for="Label" class="form-label">名称</label>
            <input
              type="text"
              class="form-control"
              id="Label"
              placeholder="名称"
              v-model="license_cd_obj.label"
            />
          </div>
          <div class="col-2">
            <label for="DistrictCd" class="form-label">ライセンスコード</label>
            <input
              type="text"
              class="form-control"
              id="DistrictCd"
              placeholder="ライセンスコード"
              v-model="license_cd_obj.license_cd"
            />
          </div>
          <div class="col-2">
            <label for="Sort" class="form-label">sort</label>
            <input
              type="number"
              class="form-control"
              id="Sort"
              placeholder="ソート"
              v-model="license_cd_obj.sort"
            />
          </div>
          <div class="col-2">
            <label for="LicenseClass" class="form-label">資格種別</label>
            <bs-select
              :options="license_class_list"
              v-model="license_cd_obj.license_class"
              :null-option="false"
              id="LicenseClass"
              :classParam="'form-select'"
            ></bs-select>
          </div>
          <div class="col-2">
            <label for="LicenseCategory" class="form-label"
              >ライセンスカテゴリ</label
            >
            <bs-select
              :options="license_category_list"
              v-model="license_cd_obj.license_category"
              :null-option="false"
              id="LicenseCategory"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-3">
            <label for="UpperLicenseCd" class="form-label"
              >競技ライセンス</label
            >
            <bs-select
              :options="license_event_cd_list"
              v-model="license_cd_obj.license_event_cd"
              :null-option="false"
              id="UpperLicenseCd"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
          <div class="col-2">
            <label for="ShortLabel" class="form-label">略称</label>
            <input
              type="text"
              class="form-control"
              id="ShortLabel"
              placeholder="名称"
              v-model="license_cd_obj.short_label"
            />
          </div>
          <div class="col-2">
            <label for="PrintLabel" class="form-label">表示名</label>
            <input
              type="text"
              class="form-control"
              id="PrintLabel"
              placeholder="名称"
              v-model="license_cd_obj.print_label"
            />
          </div>
          <!-- <div class="col-3">
            <label for="UpperLicenseCd" class="form-label"
              >昇格ライセンス</label
            >
            <bs-select
              :options="license_cd_list"
              v-model="license_cd_obj.upper_license_cd"
              :null-option="false"
              id="UpperLicenseCd"
              :PrefCd="'form-select'"
            ></bs-select>
          </div> -->
          <div class="col-2">
            <label for="ColorCd" class="form-label">色指定</label>
            <input
              type="color"
              class="form-control"
              id="ColorCd"
              placeholder="色"
              v-model="license_cd_obj.color_cd"
            />
            {{ license_cd_obj.color_cd }}
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-3">
            <label for="AgeOver" class="form-label">競技開始年齢</label>
            <div class="input-group">
              <bs-select
                :options="age_list"
                v-model="license_cd_obj.age_over"
                :null-option="'設定しない'"
                id="AgeOver"
                :PrefCd="'form-select'"
              ></bs-select>
              <span class="input-group-text">以上</span>
            </div>
          </div>
          <div class="col-3">
            <label for="AgeUnder" class="form-label">競技制限年齢</label>
            <div class="input-group">
              <bs-select
                :options="age_list"
                v-model="license_cd_obj.age_under"
                :null-option="'設定しない'"
                id="AgeUnder"
                :PrefCd="'form-select'"
              ></bs-select>
              <span class="input-group-text">以下</span>
            </div>
          </div>
          <div class="col-3">
            <label for="SalesFlg" class="form-label">販売ライセンス</label>
            <div class="input-group">
              <bs-select
                :options="sales_flg_list"
                v-model="license_cd_obj.sales_flg"
                :null-option="false"
                id="SalesFlg"
                :PrefCd="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-3">
            <label for="SalesFlg" class="form-label">保険</label>
            <div class="input-group">
              <bs-select
                :options="require_list"
                v-model="license_cd_obj.insurance_flg"
                :null-option="false"
                id="SalesFlg"
                :PrefCd="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="license_cd_obj.sales_flg == 1">
          <div class="col-3">
            <label for="Join3hour" class="form-label">3時間走行証明</label>
            <bs-select
              :options="require_list"
              v-model="license_cd_obj.join_3hour"
              :null-option="false"
              id="Join3hour"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
          <div class="col-3">
            <label for="JoinSeminarWeb" class="form-label">Web講習</label>
            <bs-select
              :options="require_list"
              v-model="license_cd_obj.join_seminar_web"
              :null-option="false"
              id="JoinSeminarWeb"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
          <div class="col-3">
            <label for="JoinSeminarCircuit" class="form-label">対面講習</label>
            <bs-select
              :options="require_list"
              v-model="license_cd_obj.join_seminar_circuit"
              :null-option="false"
              id="JoinSeminarCircuit"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3" v-if="license_cd_obj.sales_flg == 1">
          <div class="col-3">
            <label for="JoinParentFrm" class="form-label"
              >親権者フォーム(設定すると表示)</label
            >
            <bs-select
              :options="require_list"
              v-model="license_cd_obj.join_parent_frm"
              :null-option="false"
              id="JoinParentFrm"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
          <div class="col-3">
            <label for="JoinParentAccept" class="form-label"
              >親権者承諾書(設定値以下の場合表示)</label
            >
            <bs-select
              :options="require_age_list"
              v-model="license_cd_obj.join_parent_accept"
              :null-option="false"
              id="JoinParentAccept"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3" v-if="license_cd_obj.join_seminar_web == 1">
          <div class="col-4">
            <label for="MovieNo" class="form-label">動画No</label>
            <input
              type="number"
              class="form-control"
              id="MovieNo"
              placeholder="動画No"
              v-model="license_cd_obj.movie_no"
            />
          </div>
          <div class="col-3">
            <label for="PrintLaMovieSecNumbel" class="form-label"
              >動画視聴必要秒数</label
            >
            <input
              type="number"
              class="form-control"
              id="MovieSecNum"
              placeholder="秒数"
              v-model="license_cd_obj.movie_sec_num"
            />
          </div>
        </div>
      </div>
      <div class="w100 mb-5">
        <div class="row">
          <ul class="nav nav-tabs nav-fill">
            <li class="nav-item d-none">
              <button
                type="button"
                :class="tab_switch('promotion')"
                @click="tab_switch_action('promotion')"
              >
                <i class="bi bi-person-fill me-1"></i>昇降格
              </button>
            </li>
            <li class="nav-item">
              <button
                type="button"
                :class="tab_switch('exclusive')"
                @click="tab_switch_action('exclusive')"
              >
                <i class="bi bi-list-check me-1"></i>排他制御
              </button>
            </li>
            <li class="nav-item" v-if="license_cd_obj.join_seminar_web == 1">
              <button
                type="button"
                :class="tab_switch('seminar_web')"
                @click="tab_switch_action('seminar_web')"
              >
                <i class="bi bi-movie"></i>動画講習設定
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div :class="'w100 mb-5 ' + tabDisplay('promotion')">
        <div class="mb-3">
          <div class="row mb-2">
            <div class="col-10">
              <h5>昇降格ライセンス</h5>
            </div>
          </div>
        </div>
      </div>
      <div :class="'w100 mb-5 ' + tabDisplay('seminar_web')">
        <div class="mb-3" v-if="license_cd_obj.join_seminar_web == 1">
          <div class="row mb-2">
            <div class="col-10">
              <h5>WEB講習動画視聴後のテスト設定</h5>
            </div>
            <div class="col-2">
              <div class="d-grid">
                <button
                  @click="add_test"
                  class="btn btn-light btn-outline-secondary"
                >
                  <i class="bi bi-plus"></i>&nbsp;テスト追加
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="license_cd_obj.license_test.length > 0">
            <div class="col-7">テスト設問</div>
            <div class="col-5">
              <div class="row">
                <div class="col">選択肢</div>
                <div class="col"><i class="bi bi-emoji-smile"></i>正解</div>
                <div class="col"><i class="bi bi-x-circle-fill"></i>不正解</div>
              </div>
            </div>
          </div>
          <div
            class="row mb-2 border-bottom pb-2"
            v-for="(test, index) in license_cd_obj.license_test"
            :key="test"
          >
            <div class="col-7">
              <div class="input-group mb-1">
                <button @click="del_test(index)" class="btn btn-danger">
                  <i class="bi bi-trash"></i>
                </button>
                <input type="text" class="form-control" v-model="test.label" />
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="input-group">
                    <bs-select
                      :options="test_type_list"
                      v-model="test.test_type"
                      :null-option="false"
                      :classParam="'form-select'"
                    ></bs-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div
                class="row mb-1"
                v-for="(option, o_index) in test.options"
                :key="option"
              >
                <div class="input-group">
                  <button
                    @click="toggle_option_correct(index, o_index)"
                    :class="class_btn_option_correct(index, o_index)"
                  >
                    <i :class="class_icon_option_correct(index, o_index)"></i>
                  </button>
                  <input
                    type="text"
                    class="form-control"
                    v-model="option.label"
                  />
                  <button
                    @click="del_option(index, o_index)"
                    class="btn btn-danger"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-1">
              <div class="d-grid">
                <button
                  @click="add_option(index)"
                  class="btn btn-light btn-outline-secondary"
                >
                  <i class="bi bi-plus"></i>&nbsp;
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-3">
              <label for="QuestionNum" class="form-label">基礎問出題数</label>
              <bs-select
                :options="qestions_num_list_type(0)"
                v-model="license_cd_obj.qestions_num_0"
                :null-option="false"
                id="QuestionNum0"
                :classParam="'form-select'"
              ></bs-select>
            </div>
            <div class="col-3" v-if="false">
              <label for="QuestionPassNum" class="form-label"
                >基礎問合格必要数</label
              >
              <bs-select
                :options="qestions_pass_num_list_type(0)"
                v-model="license_cd_obj.qestions_pass_num_1"
                :null-option="false"
                id="QuestionPassNum0"
                :classParam="'form-select'"
              ></bs-select>
            </div>
            <div class="col-3">
              <label for="QuestionNum" class="form-label">応用問出題数</label>
              <bs-select
                :options="qestions_num_list_type(1)"
                v-model="license_cd_obj.qestions_num_1"
                :null-option="false"
                id="QuestionNum0"
                :classParam="'form-select'"
              ></bs-select>
            </div>
            <div class="col-3" v-if="false">
              <label for="QuestionPassNum" class="form-label"
                >応用問合格必要数</label
              >
              <bs-select
                :options="qestions_pass_num_list_type(1)"
                v-model="license_cd_obj.qestions_pass_num_1"
                :null-option="false"
                id="QuestionPassNum1"
                :classParam="'form-select'"
              ></bs-select>
            </div>
            <div class="col-6">
              <label for="QuestionPassNum" class="form-label">合格必要数</label>
              <bs-select
                :options="qestions_pass_num_list"
                v-model="license_cd_obj.qestions_pass_num"
                :null-option="false"
                id="QuestionPassNum"
                :classParam="'form-select'"
              ></bs-select>
            </div>
            <!-- <div class="col-6">
              <label for="QuestionNum" class="form-label">出題数</label>
              <bs-select
                :options="qestions_num_list"
                v-model="license_cd_obj.qestions_num"
                :null-option="false"
                id="QuestionNum"
                :classParam="'form-select'"
              ></bs-select>
            </div>
            <div class="col-6">
              <label for="QuestionPassNum" class="form-label">合格必要数</label>
              <bs-select
                :options="qestions_pass_num_list"
                v-model="license_cd_obj.qestions_pass_num"
                :null-option="false"
                id="QuestionPassNum"
                :classParam="'form-select'"
              ></bs-select>
            </div> -->
          </div>
        </div>
      </div>
      <!-- {{license_cd_obj.license_exclude}} -->
      <div class="w100 mb-5" v-if="false">
        <h5>料金</h5>
        <div class="row">
          <div class="col-4">
            <label for="DefaultPrice" class="form-label">ライセンス会費</label>
            <input
              type="number"
              class="form-control"
              id="DefaultPrice"
              v-model="license_cd_obj.default_price"
            />
          </div>
          <div class="col-4">
            <label for="DiscountPrice" class="form-label">割引設定料金</label>
            <input
              type="number"
              class="form-control"
              id="DiscountPrice"
              v-model="license_cd_obj.discount_price"
            />
          </div>
          <div class="col-4">
            <label for="ListPrice" class="form-label">設定料金</label>
            <p class="form-control-plaintext" id="ListPrice">
              ￥{{ license_cd_obj.list_price }}
            </p>
          </div>
        </div>
      </div>
      <div :class="'w100 mb-5 ' + tabDisplay('exclusive')">
        <h5>排他制御</h5>
        <div>
          <p class="alert alert-warning">
            下記ライセンス保持者は上記ライセンスを取得申請できません
          </p>
        </div>
        <div class="row">
          <div class="col-6 border-end">
            <h5>競技ライセンス</h5>
            <div
              class="row"
              v-for="license_event_cd in license_event_cd_list"
              :key="license_event_cd"
            >
              <div
                class="col-12"
                v-if="
                  typeof license_cd_list_filters(1, license_event_cd.id) ===
                    'object' &&
                  license_cd_list_filters(1, license_event_cd.id).length > 0
                "
              >
                {{ license_event_cd.label }}
              </div>
              <div
                class="col-4 mb-2"
                v-for="license_cd in license_cd_list_filters(
                  1,
                  license_event_cd.id
                )"
                :key="license_cd"
              >
                <div class="d-grid">
                  <button
                    type="button"
                    :class="set_license_exclude_btn_class(license_cd.id)"
                    @click="toggle_set_exclude(license_cd.id)"
                  >
                    {{ license_cd.short_label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 border-end">
            <h5>競技役員</h5>
            <div
              class="row"
              v-for="license_event_cd in license_event_cd_list"
              :key="license_event_cd"
            >
              <div
                class="col-12"
                v-if="
                  typeof license_cd_list_filters(4, license_event_cd.id) ===
                    'object' &&
                  license_cd_list_filters(4, license_event_cd.id).length > 0
                "
              >
                {{ license_event_cd.label }}
              </div>
              <div
                class="col-4 mb-2"
                v-for="license_cd in license_cd_list_filters(
                  4,
                  license_event_cd.id
                )"
                :key="license_cd"
              >
                <div class="d-grid">
                  <button
                    type="button"
                    :class="set_license_exclude_btn_class(license_cd.id)"
                    @click="toggle_set_exclude(license_cd.id)"
                  >
                    {{ license_cd.short_label }}
                  </button>
                </div>
              </div>
            </div>
            <h5 class="border-top pt-3 mt-3">講師</h5>
            <div
              class="row"
              v-for="license_event_cd in license_event_cd_list"
              :key="license_event_cd"
            >
              <div
                class="col-12"
                v-if="
                  typeof license_cd_list_filters(5, license_event_cd.id) ===
                    'object' &&
                  license_cd_list_filters(4, license_event_cd.id).length > 0
                "
              >
                {{ license_event_cd.label }}
              </div>
              <div
                class="col-4 mb-2"
                v-for="license_cd in license_cd_list_filters(
                  5,
                  license_event_cd.id
                )"
                :key="license_cd"
              >
                <div class="d-grid">
                  <button
                    type="button"
                    :class="set_license_exclude_btn_class(license_cd.id)"
                    @click="toggle_set_exclude(license_cd.id)"
                  >
                    {{ license_cd.short_label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <h5>PIT・ENJOY</h5>
            <div class="row">
              <div
                class="col-12 mb-2"
                v-for="license_cd in license_cd_list_filters([2, 3], false)"
                :key="license_cd"
              >
                <div class="d-grid">
                  <button
                    type="button"
                    :class="set_license_exclude_btn_class(license_cd.id)"
                    @click="toggle_set_exclude(license_cd.id)"
                  >
                    {{ license_cd.short_label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w100 mb-5" v-if="false">
        <h5>ライセンス</h5>
        <div
          class="mb-4"
          v-for="license_class in license_class_list"
          :key="license_class"
        >
          <div class="h5" v-if="chk_license_from_class(license_class.key)">
            {{ license_class.label }}
          </div>
          <div
            class="mb-3"
            v-for="license_event in license_event_cd_list"
            :key="license_event"
          >
            <div class="mb-3">
              <div
                class="py-2 ps-2 mb-2 bg-light border-bottom border-dark"
                v-if="
                  chk_license_from_license_event_id_and_class(
                    license_event.id,
                    license_class.key
                  )
                "
              >
                {{ license_event.label }}
              </div>
            </div>
            <div
              class="row"
              v-if="
                chk_license_from_license_event_id_and_class(
                  license_event.id,
                  license_class.key
                )
              "
            >
              <div
                class="col-3 mb-2"
                v-for="list in license_cd_filter(
                  license_event.id,
                  license_class.key
                )"
                :key="list"
              >
                <label :for="'SetPrice_' + list.id" class="form-label">{{
                  list.label
                }}</label>
                <div class="input-group">
                  <button
                    type="button"
                    :class="set_price_btn_class(list.id)"
                    @click="toggle_set_price(list.id)"
                  >
                    <i :class="set_price_icon_class(list.id)"></i>
                  </button>
                  <input
                    type="text"
                    class="form-control"
                    :id="'SetPrice_' + list.id"
                    value="未設定"
                    readonly="true"
                    disabled="disabled"
                    v-if="attach_target_license(list.id) === false"
                  />
                  <input
                    type="number"
                    class="form-control"
                    :id="'SetPrice_' + list.id"
                    v-model="list.set_price"
                    v-else-if="attach_target_license_stat(list.id) == 1"
                  />
                  <input
                    type="text"
                    class="form-control"
                    :id="'SetPrice_' + list.id"
                    value="追加不可"
                    readonly="true"
                    v-else
                    disabled="disabled"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
      style="z-index: 110"
    >
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'LicenseCdDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'ライセンスコードデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      license_event_cd_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      license_cd_obj: {},
      license_cd_list_obj: [],
      default_add_price_obj: {
        id: 0,
        stat: 0,
        license_id: this.$route.params.id,
        target_id: 0,
        price: 0
      },
      default_license_exclude_obj: {
        id: 0,
        stat: 0,
        license_id: this.$route.params.id,
        target_id: 0
      },
      default_test_obj: {
        id: 0,
        stat: 1,
        license_id: this.$route.params.id,
        label: '',
        options: []
      },
      default_test_option_obj: {
        id: 0,
        stat: 1,
        license_id: this.$route.params.id,
        test_id: 0,
        label: '',
        correct: 0
      },
      test_type_list: [
        {
          key: 0,
          label: '基礎問題'
        },
        {
          key: 1,
          label: '応用問題'
        }
      ],
      sales_flg_list: [
        {
          key: 0,
          label: '販売しない'
        },
        {
          key: 1,
          label: '販売'
        }
      ],
      require_list: [
        {
          key: 0,
          label: '未設定'
        },
        {
          key: 1,
          label: '設定する'
        }
      ],
      tab_active: 'exclusive'
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async tab_switch_action(tab) {
      this.tab_active = tab
    },
    async add_test() {
      const tmps = { ...this.default_test_obj }
      const license_cd = { ...this.license_cd_obj }
      const license_test = [...license_cd.license_test]
      license_test.push({ ...tmps })
      license_cd.license_test = license_test
      this.license_cd_obj = license_cd
    },
    async del_test(test_index) {
      const license_test = [...this.license_cd_obj.license_test]
      if (license_test[test_index]) {
        license_test.splice(test_index, 1)
      }
      this.license_cd_obj.license_test = license_test
    },
    async add_option(test_index) {
      const optmps = { ...this.default_test_option_obj }
      const license_cd = { ...this.license_cd_obj }
      const license_test = [...license_cd.license_test]
      const target_license_test = license_test[test_index]
      const target_options = [...target_license_test.options]
      target_options.push({ ...optmps })
      target_license_test.options = target_options
      license_test[test_index] = target_license_test
      license_cd.license_test = license_test
      this.license_cd_obj = license_cd
    },
    async del_option(test_index, option_index) {
      const license_cd = { ...this.license_cd_obj }
      const license_test = [...license_cd.license_test]
      if (license_test[test_index]) {
        if (
          typeof license_test[test_index].options === 'object' &&
          typeof license_test[test_index].options[option_index] === 'object'
        ) {
          license_test[test_index].options.splice(option_index, 1)
        }
      }
      license_cd.license_test = license_test
      this.license_cd_obj = license_cd
    },
    async toggle_option_correct(test_index, option_index) {
      const license_cd = { ...this.license_cd_obj }
      const license_test = [...license_cd.license_test]
      const chk = this.chk_option_correct(test_index, option_index)
      if (chk !== false && chk === 1) {
        license_test[test_index].options[option_index].correct = 0
      } else if (chk !== false && chk === 0) {
        license_test[test_index].options[option_index].correct = 1
      }
      // if(
      //   license_test[test_index]
      // ){
      //   if(
      //     typeof license_test[test_index].options === 'object'
      //     && typeof license_test[test_index].options[option_index] === 'object'
      //   ){
      //     const opt = license_test[test_index].options[option_index];
      //     if(
      //       parseInt(opt.correct) > 0
      //     ){
      //     }
      //     else{
      //       license_test[test_index].options[option_index].correct = 1;
      //     }
      //   }
      // }
      license_cd.license_test = license_test
      this.license_cd_obj = license_cd
    },

    async toggle_set_exclude(target_id) {
      const license_exclude = [...this.license_cd_obj.license_exclude]
      if (this.attach_target_license_exclude(target_id) === false) {
        const ex_obj = { ...this.default_license_exclude_obj }
        ex_obj.target_id = target_id
        ex_obj.stat = 1
        license_exclude.push(ex_obj)
        this.license_cd_obj.license_exclude = license_exclude
      } else {
        const index = license_exclude.findIndex(
          obj => obj.target_id == target_id
        )
        const ex_obj = { ...license_exclude[index] }
        if (this.attach_target_license_exclude_stat(target_id) === 0) {
          ex_obj.stat = 1
        } else if (this.attach_target_license_exclude_stat(target_id) === 1) {
          ex_obj.stat = 0
        }
        license_exclude[index] = ex_obj
        this.license_cd_obj.license_exclude = license_exclude
      }
      this.$forceUpdate()
    },

    async toggle_set_price(target_id) {
      console.log('toggle_set_price', target_id)
      console.log(
        'toggle_set_price attach_target_license',
        this.attach_target_license(target_id)
      )

      const add_price = [...this.license_cd_obj.add_price]
      if (this.attach_target_license(target_id) === false) {
        const add_obj = { ...this.default_add_price_obj }
        add_obj.target_id = target_id
        add_obj.stat = 1
        add_price.push(add_obj)
        this.license_cd_obj.add_price = add_price
      } else {
        const index = add_price.findIndex(obj => obj.target_id == target_id)
        const add_obj = { ...add_price[index] }
        if (this.attach_target_license_stat(target_id) === 0) {
          add_obj.stat = 1
        } else if (this.attach_target_license_stat(target_id) === 1) {
          add_obj.stat = 0
          add_obj.price = 0
        }
        add_price[index] = add_obj
        this.license_cd_obj.add_price = add_price
      }
      this.$forceUpdate()
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          if (response.data && response.data.body) {
            this.license_cd_list_obj = response.data.body.map(list => {
              if (this.attach_target_license_price(list.id)) {
                list.set_price = this.attach_target_license_price(list.id)
              } else {
                list.set_price = 0
              }
              return list
            })
          } else {
            this.license_cd_list_obj = []
          }
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_list_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdObj() {
      const params = {}
      await axios
        .post(
          config.BASE_API_URL + '/license_event_cd/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadLicenseEventCdObj', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdObj() {
      const params = {}
      params['id'] = this.targetid
      await axios
        .post(
          config.BASE_API_URL + '/license_cd/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadLicenseCdObj', response)
          this.license_cd_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = {}
        })
        .finally(async () => {
          await this.loadLicenseCdList()
          this.$forceUpdate()
        })
    },
    async update() {
      console.log('component methods', this.license_cd_list_obj)
      const add_price = [...this.license_cd_obj.add_price].map(add => {
        if (this.license_cd_list_obj.find(obj => obj.id == add.target_id)) {
          add.price = parseInt(
            (
              this.license_cd_list_obj.find(obj => obj.id == add.target_id) ||
              {}
            ).set_price
          )
        } else {
          add.price = 0
        }
        return add
      })
      console.log('component update add_price', add_price)
      this.license_cd_obj.add_price = add_price

      const license_exclude = [...this.license_cd_obj.license_exclude].map(
        add => {
          if (this.license_cd_list_obj.find(obj => obj.id == add.target_id)) {
            add.price = parseInt(
              (
                this.license_cd_list_obj.find(obj => obj.id == add.target_id) ||
                {}
              ).set_price
            )
          } else {
            add.price = 0
          }
          return add
        }
      )
      console.log('component update license_exclude', license_exclude)
      this.license_cd_obj.license_exclude = license_exclude

      return this.$store
        .dispatch('updateBasic', {
          data: this.license_cd_obj,
          target: 'license_cd'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadLicenseCdObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    tabDisplay: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'd-none '
        if (self_tab_active == tab) {
          tabClass = 'd-block'
        }
        return tabClass
      }
    },
    tab_switch: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'nav-link '
        // console.log('tab_switch', self_tab_active);
        if (self_tab_active == tab) {
          tabClass += 'active'
        }
        return tabClass
      }
    },
    qestions_num_list_type: function () {
      const license_test_obj = (this.license_cd_obj || {}).license_test
      return function (type) {
        const license_test = license_test_obj?.filter(
          test => test.test_type == type
        )
        const tmps = []
        tmps.push({
          key: 0,
          label: '0'
        })
        if (typeof license_test === 'object' && license_test.length > 0) {
          for (let i = 1; i <= license_test.length; i++) {
            tmps.push({
              key: i,
              label: i + '問'
            })
          }
        }
        return tmps
      }
    },
    qestions_pass_num_list_type: function () {
      const license_test_obj = (this.license_cd_obj || {}).license_test
      return function (type) {
        const license_test = license_test_obj?.filter(
          test => test.test_type == type
        )
        const tmps = []
        tmps.push({
          key: 0,
          label: '0'
        })
        if (typeof license_test === 'object' && license_test.length > 0) {
          for (let i = 1; i <= license_test.length; i++) {
            tmps.push({
              key: i,
              label: i + '問'
            })
          }
        }
        return tmps
      }
    },
    qestions_num_list: function () {
      const max =
        ((this.license_cd_obj || {}).qestions_pass_num_0
          ? (this.license_cd_obj || {}).qestions_pass_num_0
          : 0) +
        ((this.license_cd_obj || {}).qestions_pass_num_1
          ? (this.license_cd_obj || {}).qestions_pass_num_1
          : 0)
      const tmps = []
      tmps.push({
        key: 0,
        label: '0'
      })
      if (
        typeof (this.license_cd_obj || {}).license_test === 'object' &&
        (this.license_cd_obj || {}).license_test.length > 0
      ) {
        for (let i = 1; i <= max; i++) {
          tmps.push({
            key: i,
            label: i + '問'
          })
        }
      }
      return tmps
    },
    qestions_pass_num_list: function () {
      const tmps = []
      tmps.push({
        key: 0,
        label: '0'
      })
      if (
        typeof (this.license_cd_obj || {}).license_test === 'object' &&
        (this.license_cd_obj || {}).license_test.length > 0
      ) {
        for (
          let i = 1;
          i <= (this.license_cd_obj || {}).license_test.length;
          i++
        ) {
          tmps.push({
            key: i,
            label: i + '問'
          })
        }
      }
      return tmps
    },
    ...mapState({}),
    class_btn_option_correct: function () {
      const chks = this.chk_option_correct
      return function (test_index, option_index) {
        if (chks(test_index, option_index)) {
          return 'btn btn-primary'
        } else {
          return 'btn btn-light btn-outline-secondary'
        }
      }
    },
    class_icon_option_correct: function () {
      const chks = this.chk_option_correct
      return function (test_index, option_index) {
        if (chks(test_index, option_index)) {
          return 'bi bi-emoji-smile'
        } else {
          return 'bi bi-x-circle-fill'
        }
      }
    },
    chk_option_correct: function () {
      const license_cd = this.license_cd_obj
      return function (test_index, option_index) {
        const license_test = license_cd.license_test
        if (license_test[test_index]) {
          if (
            typeof license_test[test_index].options === 'object' &&
            typeof license_test[test_index].options[option_index] === 'object'
          ) {
            const opt = license_test[test_index].options[option_index]
            if (parseInt(opt.correct) > 0) {
              return 1
            } else {
              return 0
            }
          }
        }
        return false
      }
    },
    age_list: function () {
      const age = []
      for (let i = 1; i < 100; i++) {
        age.push({
          key: i,
          label: i + '歳'
        })
      }
      return age
    },
    require_age_list: function () {
      const age = []
      age.push({
        key: 0,
        label: '設定しない'
      })
      for (let i = 1; i < 20; i++) {
        age.push({
          key: i,
          label: i + '歳'
        })
      }
      return age
    },

    attach_target_license: function () {
      const add_price = (this.license_cd_obj || {}).add_price
      return function (target_id) {
        if (
          typeof add_price === 'object' &&
          add_price.find(obj => obj.target_id == target_id)
        ) {
          return add_price.find(obj => obj.target_id == target_id)
        }
        return false
      }
    },
    attach_target_license_stat: function () {
      const attach = this.attach_target_license
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).stat)
        }
        return false
      }
    },
    attach_target_license_price: function () {
      const attach = this.attach_target_license
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).price)
        }
        return false
      }
    },
    chk_license_from_class: function () {
      const lists = [...this.license_cd_list_obj]
      return function (license_class) {
        if (lists.find(list => list.license_class == license_class)) {
          return true
        }
        return false
      }
    },
    chk_license_from_license_event_id_and_class: function () {
      const lists = this.license_cd_list_obj
      return function (license_event_id, license_class) {
        if (
          typeof lists === 'object' &&
          lists.find(list => {
            if (
              license_event_id == list.license_event_cd &&
              license_class == list.license_class
            ) {
              return true
            }
            return false
          })
        ) {
          return true
        }
        return false
      }
    },
    set_price_btn_class: function () {
      const attach = this.attach_target_license_stat
      return function (target_id) {
        const obj = attach(target_id)
        if (obj === 1) {
          return 'btn btn-info'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    },
    set_price_icon_class: function () {
      const attach = this.attach_target_license_stat
      return function (target_id) {
        const obj = attach(target_id)
        if (obj === 1) {
          return 'bi bi-check-square'
        }
        return 'bi bi-square'
      }
    },
    license_event_cd_list: function () {
      const license_event_cd = this.license_event_cd_obj
      return license_event_cd.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    },
    get_license_data: function () {
      const cd_list = this.license_cd_list_obj
      return function (license_cd) {
        return cd_list.find(liense => liense.liense_cd == license_cd)
      }
    },
    get_license_param: function () {
      const get_func = this.get_license_data
      return function (license_cd, param) {
        if (
          typeof get_func(license_cd) === 'object' &&
          (typeof get_func(license_cd)[param] === 'string' ||
            typeof get_func(license_cd)[param] === 'number')
        ) {
          return get_func(license_cd)[param]
        }
        return ''
      }
    },
    license_cd_filter: function () {
      const lists = [...this.license_cd_list_obj]
      return function (license_event_id, license_class) {
        return lists
          .filter(list => {
            if (
              list.id != this.targetid &&
              license_event_id == list.license_event_cd &&
              license_class == list.license_class
            ) {
              return true
            }
            return false
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_list_obj]
      return lists
        .filter(list => {
          if (list.id != this.targetid) {
            return true
          }
          return false
        })
        .map(list => {
          list.key = list.license_id
          // list.set_price = 0;
          list.upper_license_label = this.get_license_param(
            list.upper_license_cd,
            'short_label'
          )
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list_filters: function () {
      const tmps = this.license_cd_list
      return function (license_category, license_event_id) {
        const lists = tmps
        return [...lists]
          .filter(list => {
            if (license_category == false) {
              return true
            } else if (
              typeof license_category === 'object' &&
              license_category.includes(parseInt(list.license_category))
            ) {
              return true
            } else if (list.license_category == license_category) {
              return true
            }
          })
          .filter(list => {
            if (license_event_id == false) {
              return true
            } else if (list.license_event_cd == license_event_id) {
              return true
            }
          })
          .map(list => {
            list.key = list.id
            return list
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },

    get_condition_btn_class: function () {
      const chks = this.chk_condition
      return function (license_id, index) {
        const chk = chks(license_id, index)
        console.log('get_condition_btn_class', chk, license_id, index)
        if (chk) {
          return 'btn btn-warning'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    },
    chk_condition: function () {
      const variants = (this.article_obj || {}).variants
      console.log('chk_condition variants', variants)
      // const lists = ((this.article_obj || {}).variants || {}).get_condition;
      return function (license_id, index) {
        console.log('chk_condition variants license_id', license_id, index)
        console.log('chk_condition variants variants[index]', variants[index])
        if (
          typeof variants === 'object' &&
          typeof variants[index] === 'object' &&
          variants[index] &&
          variants[index].get_condition &&
          variants[index].get_condition.find(
            get_con => get_con.license_id == license_id
          )
        ) {
          return true
        }
        return false
      }
    },
    attach_target_license_exclude: function () {
      const license_exclude = (this.license_cd_obj || {}).license_exclude
      return function (target_id) {
        if (
          typeof license_exclude === 'object' &&
          license_exclude.find(obj => obj.target_id == target_id)
        ) {
          return license_exclude.find(obj => obj.target_id == target_id)
        }
        return false
      }
    },
    attach_target_license_exclude_stat: function () {
      const attach = this.attach_target_license_exclude
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).stat)
        }
        return false
      }
    },
    set_license_exclude_btn_class: function () {
      const attach = this.attach_target_license_exclude_stat
      return function (target_id) {
        const obj = attach(target_id)
        if (obj === 1) {
          return 'btn btn-danger'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    }
  },

  async created() {
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseEventCdObj()
    await this.loadLicenseClassList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadLicenseCdObj()
      this.btnLabel = '更新'
    } else {
      this.license_cd_obj = {
        id: 0,
        label: '',
        license_cd: '',
        short_label: '',
        print_label: '',
        license_class: '',
        license_category: '',
        upper_license_cd: '',
        sort: 0,
        default_price: 0,
        discount_price: 0,
        age_over: '',
        age_under: '',
        add_price: [],
        license_exclude: []
      }
      this.btnLabel = '登録'
      await this.loadLicenseCdList()
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'ライセンスコードデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
